import { UNKNOWN_TIMEZONE } from "@utils/peopleUtils"

import Block from "../Block"

import TimezoneRow from "./TimezoneRow"
import { useTimezoneGroups } from "./useTimezoneGroups"
import { formatZoneDate } from "./timezoneDisplay"

import "./index.scss"

// Spec: Multi-TZ Sync Up Detail Group (Notion e8f3d605c41448f98d39588e55f18c8e), parent
// "People Card" (d45923fee2264c559a5512601920958c). Placement: last in the expanded People
// card (Content/index.jsx already only mounts this below Participants -- the requirements note
// "people card requirements (for Alessandra)", ecefe436ffc041b994b32ebf2b3273e1, says "below the
// People and activity stream"; web has no activity stream on this card). Rendered ONLY for
// multi-TZ TeeUps -- gated one level up (TeeupPeople/index.jsx passes isMultiTimezone, and
// Content/index.jsx only mounts <Timezone/> when it's true).
const Timezone = ({ people }) => {
  const { zoneGroups, unknownGroup, now, viewerTimezone } =
    useTimezoneGroups(people)

  const zoneCount = zoneGroups.length

  return (
    <Block className="people-timezone-group">
      <div className="people-timezone-header">
        <h4>{zoneCount} TIME ZONES</h4>
        <div className="people-timezone-header-current">
          <span>Current Time</span>
          <span>{formatZoneDate(now)}</span>
        </div>
      </div>

      <div className="people-timezone-rows">
        {zoneGroups.map(group => (
          <TimezoneRow
            key={group.timezone}
            timezone={group.timezone}
            people={group.people}
            offsetHours={group.offsetHours}
            isViewerZone={group.isViewerZone}
            viewerTimezone={viewerTimezone}
            now={now}
          />
        ))}

        {/* Spec: "UNKNOWN bucket at the BOTTOM". */}
        {unknownGroup.length > 0 && (
          <TimezoneRow
            key={UNKNOWN_TIMEZONE}
            timezone={UNKNOWN_TIMEZONE}
            people={unknownGroup}
            now={now}
            isUnknown
          />
        )}
      </div>
    </Block>
  )
}

export default Timezone
